import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer={ 
        position: "bottom",
      
        cssOverrides: {
            scrim: css`
            height:auto;
            z-index:9999999999;
        `,
            drawerBody: css`
            height:auto;
        `,
           
            drawerTitle: css`
                display: none;
            `,
            drawerContent: css`
                padding: 15px;
                margin: 0 auto;
                width: 100%;
            `,
        },
        closeButtonProps: {
            css: css`
                display: none;
            `,
        },
        enableClickThrough: true,    

     
}